export enum ManageOrgTitles {
  MANAGE_ORG = 'Manage Organisations',
}

export enum OrgManagementMode {
  CREATE = 'create',
  EDIT = 'edit',
  VIEW = 'view',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
}
